<template>
    <div class="body-style" >
        <v-form ref="form" @submit.prevent="submit" class="h-100">
            <v-row justify="center" class="mx-2">
                <v-col cols="12" class="pb-0">
                    <div style="width: 100%" class="d-flex justify-center my-2">
                        <img :src="whiteLogo" contain width="auto" height="200" />
                    </div>
                </v-col>
                <v-col cols="12" sm="6">
                    <v-text-field
                        label="اسم المستخدم"
                        v-model="userName"
                        class="rounded-BigLg"
                        solo
                        hide-details
                        :disabled="submitLoading"
                    />
                </v-col>
                <v-col cols="12"  sm="6">
                    <v-text-field
                        label="كلمة المرور"
                        v-model="password"
                        class="rounded-BigLg"
                        color=""
                        hide-details
                        id="Password"
                        :type="showPassword ? 'text' : 'password'"
                        @click:append="showPassword = !showPassword"
                        :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                        solo
                        :disabled="submitLoading"
                    />
                </v-col>
                <v-col cols="12" class="d-flex justify-center mt-2">
                    <v-btn type="submit" color="secondary" width="100%" :loading="submitLoading" class="rounded-BigLg">تسجيل الدخول</v-btn>
                </v-col>

                <v-col cols="12" class="d-flex flex-column justify-center align-center">
                    <!-- رابط المدرسة -->
                    <span class="my-2 white--text"> تابع نشاطاتنا على </span>
                    <v-btn
                        type="submit"
                        color="white"
                        elevation="2"
                        outlined
                        class="text-none rounded-fa "
                        :href="schoolFacebookPage"
                        target="_blank"
                    >
                        Facebook
                    </v-btn>
                </v-col>
            </v-row>
        </v-form>
        <div class="d-flex justify-end align-start mb-2">
            <v-bottom-navigation v-model="navigationBottom" color="primary" width="70" height="auto" class="elevation-0" >
                <a href="https://www.facebook.com/edunix.system" target="_blank">
                    <v-img src="@/assets/Powered By Edunix (Black).png" width="50" />
                </a>
            </v-bottom-navigation>
        </div>
    </div>
</template>

<script>
import { MD5 } from 'crypto-js'
import { whiteLogo, schoolFacebookPage } from '@/config/config.js'
export default {
    name: 'LoginView',
    components: {
    },

    data: () => ({
        userName: '',
        password: '',
        showPassword: false,
        submitLoading: false,
        navigationBottom: true,
        whiteLogo,
        schoolFacebookPage
    }),

    methods: {
        MD5,
        submit () {
            if ((this.userName !== null && this.userName !== '') && (this.password !== null && this.password !== '')) {
                this.submitLoading = true
                this.$store.dispatch('auth/login', {
                    userName: this.userName,
                    password: this.MD5(this.password).toString()
                }).then((response) => {
                    console.log('response', response)
                    const auth = {
                        password: this.MD5(this.password).toString(),
                        BusNo: response.BusNo,
                        DriverName: response.DriverName,
                        DriverPhone: response.DriverPhone,
                        AssistantName: response.AssistantName,
                        CenterId: response.CenterId,
                        Student: response.Student ? response.Student : []
                    }

                    localStorage.setItem('auth', JSON.stringify(auth))
                    localStorage.setItem('isAuth', true)
                    localStorage.setItem('userName', this.userName)
                    localStorage.setItem('centerId', response.CenterId)
                    this.$router.replace({
                        name: 'choose-page'
                    })
                    // const studentsLocal = response.Student.map(s => ({ accountId: s.AccountId, status: null }))
                    // localStorage.setItem('studentsLocal', JSON.stringify(studentsLocal))
                }).catch((error) => {
                    this.$eventBus.$emit('show-snackbar', 'اسم المستخدم أو كلمة المرور غير صحيحة', error)
                }).finally(() => {
                    this.submitLoading = false
                })
            } else {
                return null
            }
        }
    }
}
</script>

<style lang="scss" scoped>
@import '@/scss/variables.scss';
.body-style {
    height: 100%;
    display: flex;
    flex-direction: column;
    background-color: $background-color;
    border-bottom-left-radius: 165px;
}
.rounded-fa {
    border-radius: 12px;
}
</style>
